import React from "react";

export default function UserParcelList(){
    return (
        <div>用户包裹管理</div>
    )
}